import gql from "graphql-tag";
import graphqlClient, { fragments } from "@/http/graphql/cbs";

export const GET_CATEGORIES = `
	categories (limit: $limit, page: $page) {
		data {
			...Category
		}
		total
		per_page
	}
`;

const ADD_CATEGORY = `
	create_category (
		name: $name,
		parent_id: $parent_id,
		properties__icon: $properties__icon,
		kpiv2_details: $kpiv2_details
	) {
    	...Category
	}
`;

const UPDATE_CATEGORY = `
	update_category (
		id: $id,
		name: $name,
		parent_id: $parent_id,
		properties__icon: $properties__icon,
		kpiv2_details: $kpiv2_details
	) {
    ...Category
	}
`;

const DELETE_CATEGORY = `
	delete_category (id: $id) {
		...Category
	}
`;

const GET_KPIS = `
	kpisv2 (limit: $limit, page: $page) {
		total
		per_page
		data {
			id
			name
			tags{
				id 
				name
			}
		}
  	}
`;

export default {
	init() {},

	fetchCategories(payload) {
		const queryOptions = {
			query: gql`query ListCategories ($limit: Int!, $page: Int!) {
					${GET_CATEGORIES}
				}
				${fragments.Category}
				${fragments.Kpi}
				${fragments.KpiTaskDetail}
			`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				categories: response.data.categories.data,
				totalCategories: response.data.categories.total
			};
		});
	},

	addCategory(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation CategoriesManagementCreateCategory (
					$parent_id: Int,
					$name: String!,
					$properties__icon: String,
					$kpiv2_details: [KpiV2DetailInput]
					) {
						${ADD_CATEGORY}
					}
					${fragments.Category}
					${fragments.Kpi}
					${fragments.KpiTaskDetail}
				`,
				variables: {
					name: payload.name,
					parent_id: payload.parent_id || null,
					properties__icon: payload.properties__icon || null,
					kpiv2_details: payload.kpiv2_details || []
				}
			})
			.then(response => response.data.create_category);
	},

	updateCategory(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation CategoriesManagementUpdateCategory (
					$id: Int!,
					$name: String!
					$parent_id: Int,
					$properties__icon: String,
					$kpiv2_details: [KpiV2DetailInput]
					) {
						${UPDATE_CATEGORY}
					}
					${fragments.Category}
					${fragments.Kpi}
					${fragments.KpiTaskDetail}
				`,
				variables: {
					id: payload.id,
					name: payload.name,
					parent_id: payload.parent_id,
					properties__icon: payload.properties__icon || null,
					kpiv2_details: payload.kpiv2_details || []
				}
			})
			.then(response => response.data.update_category);
	},

	deleteCategory(categoryId) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation CategoriesManagementDeleteCategory ($id: Int!) {
				${DELETE_CATEGORY}
			}
			${fragments.Category}
			${fragments.Kpi}
			${fragments.KpiTaskDetail}
		`,
				variables: {
					id: categoryId
				}
			})
			.then(response => response.delete_category);
	},
	fetchKpisV2(payload) {
		const queryOptions = {
			query: gql`query ListCategories ($limit: Int!, $page: Int!) {
					${GET_KPIS}
				}
			`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				kpisv2: response.data.kpisv2.data,
				total: response.data.kpisv2.total
			};
		});
	}
};
